<template>
  <div
    class="freestyle-canvas-preview container-fluid overflow-hidden"
    v-if="slide && slide.id"
  >
    <!-- <div class="preview-header" /> -->
    <PreviewBlockEditor
      v-for="(block) in previewBlocksArray"
      class="preview-block-editor"
      :key="`preview-${slide.id}-${block.id}`"
      :block="{...block, id: `${slide.id}-${block.id}`}"
      :slide-id="slide.id"
      :style="blockStyle"
    />
    <!-- <div class="preview-footer" /> -->
  </div>
</template>

<script>
import util from '@/util'
import { DefaultCanvasBlocks } from '../../utils/CanvasBlocksLayout'
import PreviewBlockEditor from './PreviewBlockEditor.vue'

export default {
  components: {
    PreviewBlockEditor,
  },
  props: {
    slide: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      canvasWidth: null,
    }
  },
  computed: {
    canvasBlocks() {
      if (!this.slide) return {}
      if (!this.slide.canvasBlocks && !this.slide.canvasBlocksUrl) {
        return DefaultCanvasBlocks(this.slide.id)
      }
      return this.slide.canvasBlocks
    },

    previewBlocksArray() {
      const originalBlocks = util.fromMapToArray(this.canvasBlocks, 'id')
      return originalBlocks || []
    },

    blockStyle() {
      // FIXME: Find another way to calculate the scale ratio
      const scaleRatio = (this.canvasWidth - 44) / 1200 + 5 / this.canvasWidth
      return {
        transform: `scale(${scaleRatio})`,
      }
    },

  },

  mounted() {
    this.canvasElem = document.querySelector('.freestyle-canvas-preview')
    this.canvasWidth = this.canvasElem.offsetWidth
    this.listenResizeEvent()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },

  methods: {
    listenResizeEvent() {
      window.addEventListener('resize', this.onResize)
    },

    onResize() {
      this.canvasWidth = this.canvasElem.offsetWidth
    },
  },
}
</script>

<style lang="scss" scoped>
.freestyle-canvas-preview {
  width: 100%;
  height: 100%;
  padding-left: 1px;
  position: relative;
  z-index: 1;
}

.preview-block-editor {
  position: absolute;
  transform-origin: top left;
  top: 8%;
}

.preview-header {
  height: 60px;
}

.preview-footer {
  height: 60px;
}

</style>
